module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-runtime/node_modules/core-js/library/modules/_library.js
// module id = 49
// module chunks = 0